import React from "react";
import { Navigate } from "react-router-dom";
import { SafetyInspectionPoint } from "../../../../amorg-common";
import { colors } from "../../../../designSystem/colors/color";
import { ToolBarButton } from "../../../../designSystem/compositeComponents/ButtonToolBar";
import { Flex, FlexItem } from "../../../../designSystem/compositeComponents/FlexHelpers";
import { ListRow } from "../../../../designSystem/compositeComponents/ListRow";
import { Icon } from "../../../../designSystem/icons/Icons";
import { Small, Span } from "../../../../designSystem/typography/Body";
import { txt } from "../../../../txt";
import { toDateTimeString } from "../../../../utils/date";
import { getInspectionPointStatusIconDetails } from "../../../../utils/facilityHelper";
import { ResponsiveDeviceViewLimiter } from "../../../../designSystem/ResponsiveDeviceViewLimiter";


type InspectionPanelProps = {
    activityId:string,
    inspection:SafetyInspectionPoint
}
export function InspectionPanel(props:InspectionPanelProps):JSX.Element
{
    const [redirect, setRedirect] = React.useState('');

    const inspection = props.inspection.inspectionPoint;
    const result = props.inspection.inspectionResult;

    const { icon, color } = getInspectionPointStatusIconDetails(result.status);

    return (
        <>

            {redirect && <Navigate to={redirect} />}

            <ListRow
                level={3}
                styleVariant="outlined"
                icon={icon}
                iconColor={color}
                onClick={() => setRedirect(`/safetyinspections/${props.activityId}/inspections/${result.id}`)}
                content={
                    <Flex gap={10} justifyContent='stretch' alignItems="center">

                        <Flex gap={10} style={{flexGrow:1}}>
                            <div>{inspection.title}</div>

                            <ResponsiveDeviceViewLimiter desktop tablet>
                                <Span size="14px">{txt.getDynamic(`InspectionPointStatus_${result.status}`)}</Span>
                            </ResponsiveDeviceViewLimiter>
                        </Flex>
                        
                        <FlexItem width="34px">
                            {props.inspection.inspectionResult.comment.length > 0 && <ToolBarButton icon="interface_glyph_comment" variant="clean" tooltip={props.inspection.inspectionResult.comment} />}
                        </FlexItem>
                        <FlexItem width="34px">
                            {props.inspection.inspectionResult.files.length > 0 && <ToolBarButton icon="photo_library_thin" variant="clean" tooltip={"Der er tilknyttet " + (props.inspection.inspectionResult.files.length === 1 ? (props.inspection.inspectionResult.files.length + " billede") : (props.inspection.inspectionResult.files.length + " billeder"))} />}
                        </FlexItem>

                        <ResponsiveDeviceViewLimiter desktop>
                            <>
                                <Flex gap={8} style={{width:'160px'}}>
                                    <Icon size='x-small' name='interface_user_user' color={result.initialInspectionUser===null ? colors.icon.error : colors.icon.active} />
                                    <Small style={{
                                        color:result.initialInspectionUser===null ? colors.text.state.error : colors.text.state.info
                                    }}>
                                        {result.initialInspectionUser===null ? '-' : result.initialInspectionUser.name}
                                    </Small>
                                </Flex>

                                <Flex gap={4} style={{width:'160px'}}>
                                    <Icon size='x-small' name='clock' color={result.initialInspectionUser===null ? colors.icon.error : colors.icon.active} />
                                    <Small style={{
                                        color:result.initialInspectionDate===null ? colors.text.state.error : colors.text.state.info
                                    }}>
                                        {result.initialInspectionDate===null ? '-' : toDateTimeString(result.initialInspectionDate)}
                                    </Small>
                                </Flex>
                            </>
                        </ResponsiveDeviceViewLimiter>

                    </Flex>
                } />
        </>
    );
}